import React from "react";
import logo from "../../assets/kiosqu-logo.png"
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

export default function Header() {
  const [underlineLeft, setUnderlineLeft] = useState(0);
  const [underlineWidth, setUnderlineWidth] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [bgOpacity, setBgOpacity] = useState(0);
  const navRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const activeEl = navRef.current?.querySelector("a.active");
    if (activeEl) {
      const navBox = navRef.current.getBoundingClientRect();
      const elBox = activeEl.getBoundingClientRect();
      setUnderlineLeft(elBox.left - navBox.left);
      setUnderlineWidth(elBox.width);
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const maxScroll = 300; // adjust threshold before 2nd section
      const opacity = Math.min(scrollY / maxScroll, 1); // 0 → 1
      setBgOpacity(opacity);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="flex flex-col py-px">
      <header
        className="fixed top-0 left-0 w-full px-6 border-b min-h-[65px] z-50 transition-colors duration-300"
        style={{
          backgroundColor: `rgba(255, 255, 255, ${bgOpacity})`,
          backdropFilter: "blur(6px)",
        }}
      >
        <div className="flex justify-between items-center w-full min-h-16">
          {/* Logo */}
          <a href="/" className="flex items-center">
            <img src={logo} alt="Company Logo" className="w-[78px]" />
          </a>

          {/* Desktop Nav */}
          <nav
            ref={navRef}
            className="relative hidden md:flex gap-7 text-sm font-medium text-teal-600"
          >
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive ? "active text-amber-500" : "hover:text-amber-500"
              }
            >
              Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "active text-amber-500" : "hover:text-amber-500"
              }
            >
              About
            </NavLink>
            <NavLink
              to="/modules"
              className={({ isActive }) =>
                isActive ? "active text-amber-500" : "hover:text-amber-500"
              }
            >
              Modules
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "active text-amber-500" : "hover:text-amber-500"
              }
            >
              Contact
            </NavLink>

            {/* Sliding underline */}
            <span
              className="absolute -bottom-2 h-0.5 bg-amber-500 transition-all duration-300"
              style={{ left: underlineLeft, width: underlineWidth }}
            />
          </nav>

          {/* CTA (desktop only) */}
          <button
            onClick={() => navigate("/contact")}
            className="hidden md:block px-3.5 py-2 bg-teal-600 rounded-xl text-white hover:bg-teal-700 transition-colors"
          >
            Early Access
          </button>

          {/* Hamburger (mobile only) */}
          <button
            className="md:hidden text-teal-600 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {/* Simple hamburger icon */}
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {menuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </header>

      {/* Spacer */}
      <div className="pt-[65px]"></div>

      {/* Mobile Menu Drawer */}
      {menuOpen && (
        <div className="md:hidden fixed top-[65px] left-0 w-full bg-white shadow-md z-40">
          <nav className="flex flex-col gap-4 p-4 text-teal-600 font-medium">
            <NavLink to="/" onClick={() => setMenuOpen(false)}>
              Home
            </NavLink>
            <NavLink to="/about" onClick={() => setMenuOpen(false)}>
              About
            </NavLink>
            <NavLink to="/modules" onClick={() => setMenuOpen(false)}>
              Modules
            </NavLink>
            <NavLink to="/contact" onClick={() => setMenuOpen(false)}>
              Contact
            </NavLink>
            <button
              onClick={() => {
                setMenuOpen(false);
                navigate("/contact");
              }}
              className="px-3 py-2 bg-teal-600 rounded-xl text-white hover:bg-teal-700 transition-colors"
            >
              Early Access
            </button>
          </nav>
        </div>
      )}
    </div>

  );
}
